import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import '../styles/landing.css';
import '../styles/how-it-works-driver.css';

type HowItWorksComingSoonPageProps = {
  appName: string;
  guideName: string;
  description: string;
};

const HowItWorksComingSoonPage: React.FC<HowItWorksComingSoonPageProps> = ({
  appName,
  guideName,
  description,
}) => {
  return (
    <div className="landing-shell">
      <Header />
      <main>
        <section className="driver-how-coming-soon">
          <div className="container">
            <div className="driver-how-coming-card">
              <Link className="driver-how-back-link" to="/how-it-works">
                Back to guide hub
              </Link>
              <span className="sw-eyebrow">{appName}</span>
              <h1>{guideName}</h1>
              <p>{description}</p>
              <div className="driver-how-coming-badge">Coming soon</div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default HowItWorksComingSoonPage;
